import { Component, OnInit } from '@angular/core';
import { UserpilotReloader } from '../../helper/userpilot-reloader.component';
import { ScenarioComparisonService } from './scenario-comparison.service';

@Component({
  selector: 'app-scenario',
  templateUrl: './scenario.component.html',
  styleUrls: ['./scenario.component.scss'],
  providers: [ScenarioComparisonService]
})
export class ScenarioComponent extends UserpilotReloader implements OnInit {

  constructor() {
    super();
  }


  ngOnInit() {
  }

}
